// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"455":"b280dc9e","692":"b1197c73","977":"7c1bca37"}[chunkId] + ".chunk.js";
};